module.exports = __webpack_public_path__ + "img/DSC_9581-2.a5f5ed3f.jpeg";